import IDimensions from '../model/IDimensions';

function buildId(dimensions: IDimensions): string {
  return `${dimensions.country}_${dimensions.brand}_insurance_block_input`;
}

export const insuranceBlockInputStorage = {
  get: (dimensions: IDimensions) => {
    return JSON.parse(localStorage.getItem(buildId(dimensions)) ?? 'null');
  },
};
